/**
 * DIEUKYDIEU.TV - EXPLORE EDITORIAL SPOTLIGHT MODULE
 * Apple News style asymmetric top stories: Lead Hero story + 3 curated picks with hairline dividers.
 */

import { getSectionsData } from './explore.js';
import { t } from './i18n.js';

export function renderExploreSpotlight() {
    const spotlightEl = document.getElementById('explore-spotlight-section');
    if (!spotlightEl) return;

    const sections = getSectionsData();
    if (!sections || sections.length === 0) {
        spotlightEl.style.display = 'none';
        return;
    }

    spotlightEl.style.display = 'flex';

    // Lead Story: Category 1's lead article
    const leadSec = sections[0];
    const leadArt = (leadSec && leadSec.articles && leadSec.articles[0]) ? leadSec.articles[0] : null;

    // Curated 3 Picks from distinct categories
    const picks = [];
    if (sections[1] && sections[1].articles && sections[1].articles[0]) {
        picks.push({
            art: sections[1].articles[0],
            kicker: sections[1].name
        });
    }
    if (sections[3] && sections[3].articles && sections[3].articles[0]) {
        picks.push({
            art: sections[3].articles[0],
            kicker: sections[3].name
        });
    }
    if (sections[4] && sections[4].articles && sections[4].articles[0]) {
        picks.push({
            art: sections[4].articles[0],
            kicker: sections[4].name
        });
    }

    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const datelineStr = `HÔM NAY · ${day} THÁNG ${month}`;

    let picksHtml = '';
    picks.forEach((p, idx) => {
        const item = p.art;
        picksHtml += `
            <article class="pick-item" data-pick-idx="${idx}" tabindex="0" role="article" aria-label="${item.title}">
                <div class="pick-thumb" style="background-image: url('${item.img}')" loading="lazy" aria-hidden="true"></div>
                <div class="pick-info">
                    <span class="pick-kicker">${item.tag || p.kicker}</span>
                    <h4 class="pick-title">${item.title}</h4>
                    <p class="pick-desc">${item.desc}</p>
                </div>
            </article>
        `;
    });

    const leadHtml = leadArt ? `
        <article class="spotlight-lead-card" id="spotlight-lead-card" tabindex="0" role="article" aria-label="${leadArt.title}">
            <div class="lead-thumb-wrap">
                <div class="lead-thumb-bg" style="background-image: url('${leadArt.img}')" loading="lazy"></div>
                <span class="lead-kicker-badge">${leadArt.tag || 'Câu chuyện nổi bật'}</span>
            </div>
            <div class="lead-content">
                <span class="lead-kicker">${leadSec.name}</span>
                <h3 class="lead-title">${leadArt.title}</h3>
                <p class="lead-desc">${leadArt.desc}</p>
            </div>
        </article>
    ` : '';

    spotlightEl.innerHTML = `
        <div class="spotlight-header">
            <div class="spotlight-badge">
                <span class="material-symbols-rounded">auto_awesome</span>
                <span data-i18n="spotlight_title">${t('spotlight_title') || 'BÀI CHỌN LỌC'}</span>
            </div>
            <div class="spotlight-dateline">${datelineStr}</div>
        </div>
        <div class="spotlight-grid">
            ${leadHtml}
            <div class="spotlight-picks-col">
                <div class="picks-list">
                    ${picksHtml}
                </div>
            </div>
        </div>
    `;

    // Bind Lead Story Card
    const leadCardEl = spotlightEl.querySelector('#spotlight-lead-card');
    if (leadCardEl && leadArt) {
        const openLead = () => {
            if (typeof window.openStoryDetail === 'function') {
                window.openStoryDetail(leadArt);
            }
        };
        leadCardEl.addEventListener('click', openLead);
        leadCardEl.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                openLead();
            }
        });
    }

    // Bind Pick Items
    const pickEls = spotlightEl.querySelectorAll('.pick-item');
    pickEls.forEach((el, idx) => {
        const itemArt = picks[idx] ? picks[idx].art : null;
        if (itemArt) {
            const openPick = () => {
                if (typeof window.openStoryDetail === 'function') {
                    window.openStoryDetail(itemArt);
                }
            };
            el.addEventListener('click', openPick);
            el.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    openPick();
                }
            });
        }
    });
}
